module.exports = __webpack_public_path__ + "static/media/ball_5_0.3b04ccb9.mp3";